<template>
		<!-- Container-fluid starts-->
		<div class="container-fluid">
            <div v-show="process === 'edit' " class="row">
                <div class="col-sm-12">
                    <div class="row ml-2">
                        <h4 class="text-primary mt-3">{{ $t('calendar.editCld') }}</h4>
                        <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                    </div>
                    <form class="theme-form">
                        <div class="row col-sm-12">
                            <div class="row ml-1" style="font-size: 18px;">
                                <span class= "text-dark f-w-600 ml-3"> 
                                    {{ $t("calendar.day")}} 
                                    <span class= "text-info"> :
                                        <span>{{ parseInt(day) }} / </span>
                                        <span>{{month}} / </span> 
                                        <span>{{year}}</span>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="row col-sm-12">
                                <div class="mt-2 col-sm-2 gradient-pw ">
                                    <label for="snRs" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.snRs') }}</label>
                                    <b-form-select label="snRs" v-model="snRs" :options="rsDigitList" > </b-form-select>
                                </div>
                                <div class="mt-2 col-sm-2 gradient-pw">
                                    <label for="snDeg" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.snDeg') }}</label>
                                    <b-form-select label="snDeg" v-model="snDeg" :options="rsDegList" > </b-form-select>
                                </div>
                                <div class="mt-2 col-sm-2 gradient-pw">
                                    <label for="snLda" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.snLda') }}</label>
                                    <b-form-select label="snLda" v-model="snLda" :options="minList" > </b-form-select>
                                </div>
                                <!-- <div class="mt-2 col-sm-2 gradient-yw">
                                    <label for="mnRs" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.mnRs') }}</label>
                                    <b-form-select label="mnRs" v-model="mnRs" :options="rsDigitList" > </b-form-select>
                                </div>
                                <div class="mt-2 col-sm-2 gradient-yw">
                                    <label for="mnDeg" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.mnDeg') }}</label>
                                    <b-form-select label="mnDeg" v-model="mnDeg" :options="rsDegList" > </b-form-select>
                                </div>
                                <div class="mt-2 col-sm-2 gradient-yw">
                                    <label for="mnLda" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.mnLda') }}</label>
                                    <b-form-select label="mnLda" v-model="mnLda" :options="minList" > </b-form-select>
                                </div> -->
                            </div>
                            <!-- <div class="row col-sm-12">
                                <div class="mt-2 col-sm-3 gradient-lbw ">
                                    <label for="mnMv" class="text-dark f-w-600" style="font-size: 14px">{{ $t('calendar.mnMv') }}</label> 
                                    <b-form-timepicker 
                                        v-model="mnMv" 
                                        reset-button
                                        size = "md"
                                        :label-reset-button="$t('lucking.reset')"
                                        :label-close-button="$t('lucking.close')"
                                        label-no-time-selected=""
                                        locale="th">
                                    </b-form-timepicker>
                                </div>
                                <div class="mt-2 col-sm-2 gradient-lbw">
                                    <label for="ausMn" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.ausMn') }}</label>
                                    <b-form-select label="ausMn" v-model="ausMn" :options="ausMnList" > </b-form-select>
                                </div>
                                <div class="mt-2 col-sm-2 gradient-lbw">
                                    <label for="ausMin" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.ausMin') }}</label>
                                    <b-form-select label="ausMin" v-model="ausMin" :options="minList" > </b-form-select>
                                </div>
                                <div class="mt-2 col-sm-2 gradient-lbw">
                                    <label for="dithyMn" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.dithyMn') }}</label>
                                    <b-form-select label="dithyMn" v-model="dithyMn" :options="dithyMnList" > </b-form-select>
                                </div>
                                <div class="mt-2 col-sm-2 gradient-lbw">
                                    <label for="dithyMin" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.dithyMin') }}</label>
                                    <b-form-select label="dithyMin" v-model="dithyMin" :options="minList" > </b-form-select>
                                </div>
                            </div>   -->
                            <!-- <div class="row col-sm-9">
                                <div class="mt-2 col-sm-3 gradient-gw">
                                    <label for="upRam" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.upRam') }}</label>
                                    <b-form-select label="upRam" v-model="upRam" :options="upRamList" > </b-form-select>
                                </div>
                                <div class="mt-2 col-sm-3 gradient-gw">
                                    <label for="upRamAt" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.upRamAt') }}</label>
                                    <b-form-select label="upRamAt" v-model="upRamAt" :options="upRamAtList" > </b-form-select>
                                </div>
                                <div class="mt-2 col-sm-3 gradient-gw">
                                    <label for="mnMth" class="text-dark f-w-600" style="font-size: 14px" >{{ $t('calendar.mnMth') }}</label>
                                    <b-form-select label="mnMth" v-model="mnMth" :options="mnMthList" > </b-form-select>
                                </div>                                
                            </div>                                                   -->
                        </div>
                        <div class="form-group my-2 mx-auto">
                            <button class="btn btn-warning btn-block" style="font-size:20px" type="button" @click="$bvModal.show('bv-modal-saveEdit')">{{ $t('calendar.saveEdit') }}</button>
                        </div> 
                    </form>
                </div>
            </div>
            <div class="mt-2 col-sm-5">
                <label for="selectedYear" class="text-dark f-w-600" style="font-size: 20px" >{{ $t('lucking.year') }}</label>
                <b-form-select class="border-info" label="selectedYear" v-model="selectedYear" :options="yearList" @change="getCalendarByYear"> </b-form-select>
            </div>
            <b-modal id="bv-modal-saveEdit" hide-footer>
                <template #modal-title>
                {{ $t('calendar.saveEditTitle') }}
                </template>
                <div class="d-block text-center">
                <h3>{{$t('calendar.confirm2SaveEdit') }}</h3>
                </div>
                <b-button class="mt-3 btn-primary" block @click="$bvModal.hide('bv-modal-saveEdit')">{{$t('lucking.cancel') }}</b-button>
                <b-button class="mt-3 btn-danger" block @click="handleEdit">{{$t('calendar.saveEdit') }}</b-button>
            </b-modal>
            <div>
                <div class="row">
                    <h4 class="mb-1 mt-4 ml-3 f-w-600">{{ $t('calendar.title') }}</h4>                
                    <b-col lg="4" class="ml-3 mt-3">
                        <b-form-group
                        :label="$t('refill.filter')"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            id="filter-input"
                            v-model="filter"
                            type="search"
                            :placeholder="$t('refill.typeToSearch')"
                            class="text-info"
                            style="font-size: 16px;"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                {{ $t('refill.clear') }}
                            </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="5" class="my-1">
                        <b-form-group
                        v-model="sortDirection"
                        :label="$t('refill.filterOn')"
                        :description= "$t('refill.uncheck')"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                        >
                        <b-form-checkbox-group
                            v-model="filterOn"
                            :aria-describedby="ariaDescribedby"
                            class="mt-1 text-info"
                            plain
                        >
                            <b-form-checkbox value="year">{{ $t('calendar.year') }}</b-form-checkbox>                                                                
                            <!-- <b-form-checkbox value="mnMth">{{ $t('calendar.mnMth') }}</b-form-checkbox>
                            <b-form-checkbox value="upRam">{{ $t('calendar.upRam') }}</b-form-checkbox>    -->
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>   
                </div>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="white"
                    show-empty
                    sort-icon-left
                    stacked="sm"
                    responsive="sm"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFiltered"
                >
                    <template #cell(edit)="row" >
                        <b-button pill size="sm" @click="actEdit(row.item)" class="m-1">
                           <span class="f-w-600" style="font-size: 16px;"> {{ $t('calendar.edit') }}</span>
                        </b-button>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('refill.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
            </div>            
        </div>
        <!-- Container-fluid Ends-->
</template>
<script>
import {  saveWithId ,getCalendar } from "../../firebase"
import  { year , rsDigitList, rsDegList, mnMthList, upRamAtList, ausMnList, dithyMnList, minList}  from "../../constants/hor-th"
export default {
	data(){
		return{
            selectedYear : "2504 /1961",
            yearList : [],  
            // upRamList : [ 
            //     {text:"ขึ้น", value: "ข"},
            //     {text:"แรม", value: "ร"}
            // ],
            // upRamAtList : upRamAtList,
            // mnMthList :  mnMthList,            
            rsDigitList : rsDigitList,
            rsDegList : rsDegList,
            minList : minList,
            // dithyMnList : dithyMnList,
            // ausMnList : ausMnList,
            process : "info",
            clndrId: '',
            day : '',
            month: '',
            year: '',
            snRs : '',
            snDeg : '',
            snLda : '',   
            // mnRs : '',
            // mnDeg : '',
            // mnLda : '', 
            // mnMv: '',
            // ausMn: '',
            // ausMin: '',
            // dithyMn: '',
            // dithyMin: '',
            // dayNum : '',                                        
            // upRam: '',
            // upRamAt: '',      
            // mnMth: '',
            items: [],
            fields: [
                { key: 'dateTS', label: this.$t('calendar.dateTS'), sortable: true, variant: 'secondary', 
                    formatter: value => {
                        return this.$moment(value).format("DD/MM/YYYY")
                }},                 
                { key: 'snRs', label: this.$t('calendar.snRs'), sortable: true , variant: 'danger' },
                { key: 'snDeg', label: this.$t('calendar.snDeg'), sortable: true , variant: 'danger' },
                { key: 'snLda', label: this.$t('calendar.snLda'), sortable: true, variant: 'danger'  },
                // { key: 'mnRs', label: this.$t('calendar.mnRs'), sortable: true , variant: 'warning' },
                // { key: 'mnDeg', label: this.$t('calendar.mnDeg'), sortable: true , variant: 'warning' },
                // { key: 'mnLda', label: this.$t('calendar.mnLda'), sortable: true , variant: 'warning' },
                // { key: 'mnMv', label: this.$t('calendar.mnMv'), sortable: true , variant: 'info' },
                // { key: 'ausMn', label: this.$t('calendar.ausMn'), sortable: true, variant: 'info'  },
                // { key: 'ausMin', label: this.$t('calendar.ausMin'), sortable: true, variant: 'info'  },
                // { key: 'dithyMn', label: this.$t('calendar.dithyMn'), sortable: true, variant: 'info'  },
                // { key: 'dithyMin', label: this.$t('calendar.dithyMin'), sortable: true, variant: 'info'  },
                // { key: 'upRam', label: this.$t('calendar.upRam'), sortable: true , variant: 'success' , 
                //     formatter: value => {
                //         return this.$t(`calendar.${value}`)
                // }},
                // { key: 'upRamAt', label: this.$t('calendar.upRamAt'), sortable: true , variant: 'success' },
                // { key: 'mnMth', label: this.$t('calendar.mnMth'), sortable: true , variant: 'success' },
                { key: 'day', label: this.$t('calendar.day'), sortable: true, variant: 'secondary'},                 
                { key: 'month', label: this.$t('calendar.month'), sortable: true,variant: 'secondary' },
                { key: 'year', label: this.$t('calendar.year'), sortable: true, variant: 'secondary'},                
                { key: 'edit', label: this.$t('refill.action'), variant: 'white'},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'dateTS',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
		}
	},
    computed: {
      sortOptions() {

        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
    },
	mounted(){
        this.yearList = year
        this.getCalendarByYear()
	},
	methods:{ 
        async getCalendarByYear(){
            await getCalendar( `${this.selectedYear.split('/')[0].trim()}` , res =>{
                this.items = res
                this.totalRows = res.length
            })
        },

        onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
        },
        async handleEdit(){
            let msg = 'completed'
            if (this.snRs ===''){
                msg = 'calendar.snRsMsg'
            } else if (this.snDeg ===''){
                msg = 'calendar.snDegMsg'
            } else if (this.snLda ===''){
                msg = 'calendar.snLdaMsg'
            // } else if (this.mnRs ===''){
            //     msg = 'calendar.mnRsMsg'
            // } else if (this.mnDeg ===''){
            //     msg = 'calendar.mnDegMsg'
            // } else if (this.mnLda ===''){
            //     msg = 'calendar.mnLdaMsg'
            // } else if (this.mnMv ===''){
            //     msg = 'calendar.mnMvMsg'
            // } else if (this.ausMn ===''){
            //     msg = 'calendar.ausMnMsg'
            // } else if (this.ausMin ===''){
            //     msg = 'calendar.ausMinMsg'
            // } else if (this.dithyMn ===''){
            //     msg = 'calendar.dithyMnMsg'
            // } else if (this.dithyMin ===''){
            //     msg = 'calendar.dithyMinMsg'
            // } else if (this.upRam ===''){
            //     msg = 'calendar.upRamMsg'
            // } else if (this.upRamAt ===''){
            //     msg = 'calendar.upRamAtMsg'
            // } else if (this.mnMth ===''){
            //     msg = 'calendar.mnMthMsg'
            }  
            if (msg === 'completed'){
                // console.log(`upRam =>${JSON.stringify(this.upRam)}`)
                let payload = {
                    // ausMin: `${this.ausMn}-${this.ausMin}`,
                    // dithyMin: `${this.dithyMn}-${this.dithyMin}`,
                    // mnMv: this.mnMv == '' ? "*" : `${this.mnMv.split(':')[0]}.${this.mnMv.split(':')[1]}`,
                    // mnDate:`${this.dayNum}-${this.upRam}-${this.upRamAt}-${this.mnMth}`,
                    // moon: `${this.mnRs}-${this.mnDeg}-${this.mnLda}`,
                    sun: `${this.snRs}-${this.snDeg}-${this.snLda}`
                }
                // console.log(`saveEdit clndrId: ${this.clndrId} on payload =>${JSON.stringify(payload, null, 2)}`)
               await saveWithId('Calendar', this.clndrId, payload)
                .then(async()=>{
                    await this.getCalendarByYear()
                    this.$toasted.show(this.$t('forecast.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
                })
                this.process = "info",
                this.$bvModal.hide('bv-modal-saveEdit')
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },

        actEdit(item) {
            this.clndrId = item.clndrId
            this.year = item.year
            this.month = item.month
            this.day = item.day
            this.dayNum = item.dayNum
            // this.upRam= item.upRam
            // this.upRamAt=item.upRamAt      
            // this.mnMth = item.mnMth
            // this.ausMn = item.ausMn
            // this.ausMin = item.ausMin
            // this.dithyMn = item.dithyMn
            // this.dithyMin = item.dithyMin
            // this.mnMv = item.mnMv
            // this.mnRs = item.mnRs
            // this.mnDeg = item.mnDeg
            // this.mnLda = item.mnLda
            this.snRs = item.snRs
            this.snDeg = item.snDeg
            this.snLda = item.snLda
            this.process = "edit"   // to pop up Update subMenu
            // console.log(`editItems => ${JSON.stringify(item , null , 2)}`)
        }, 
    }
}
</script>
<style scoped>
.gradient-lbw {
  background: linear-gradient(45deg, rgb(0, 255, 251), white);
}
.gradient-yw {
  background: linear-gradient(45deg, yellow, white);
}

.gradient-pw {
  background: linear-gradient(45deg, pink, white);
}
.gradient-gw {
  background: linear-gradient(45deg, rgb(140, 228, 140), white);
}

</style>
